import React from 'react'

/* Style */
import './PublicHome.css'

/**
 * Modulos
 */
import { Carousel } from 'antd'
import PublicTopBar from '../publicTopBar/PublicTopBar';
import PublicChamps from '../publicChamps/PublicChamps';
import PublicEvents from '../publicEvents/PublicEvents';
import PublicPhotos from '../publicPhotos/PublicPhotos';

/**
 * Components
 */
/*
import CompetitorsList from '../shared/competitorsList/CompetitorsList'
import RegistrationForm from '../shared/registrationForm/RegistrationForm'
import SwitchingsList from '../shared/switchingsList/SwitchingsList'
import ScheduleContainer from '../shared/schedule/ScheduleContainer'
*/

const PublicHomeView = (props) => {
    return (
        <div>
            <a id="start"><PublicTopBar /></a>

            <Carousel autoplay className='publicHomeCarousel'>
                <div>
                    <div className='publicHomeCarouselImage' style={{ backgroundImage: `url(${props.publicHomeImg01})` }} />
                </div>

                <div>
                    <div className='publicHomeCarouselImage' style={{ backgroundImage: `url(${props.publicHomeImg02})` }} />
                </div>

                <div>
                    <div className='publicHomeCarouselImage' style={{ backgroundImage: `url(${props.publicHomeImg03})` }} />
                </div>

                <div>
                    <div className='publicHomeCarouselImage' style={{ backgroundImage: `url(${props.publicHomeImg04})` }} />
                </div>

                <div>
                    <div className='publicHomeCarouselImage' style={{ backgroundImage: `url(${props.publicHomeImg05})` }} />
                </div>

                <div>
                    <div className='publicHomeCarouselImage' style={{ backgroundImage: `url(${props.publicHomeImg06})` }} />
                </div>
            </Carousel>

            <div className='publicHomeAdSense'></div>

            <PublicChamps />

            <PublicEvents />

            <PublicPhotos />

            {/* <div className='publicHomeModules'>
                <div className='publicHomeModulesCentered'>
                    <div className='publicHomeModuleImg'>
                        <Link to={'/index/publicChamps'} style={{ color: 'white' }}>
                            <i className="fas fa-trophy"></i>
                        </Link>
                    </div>
                    <div className='publicHomeModuleText'>
                        <Link to={'/index/publicChamps'} style={{ color: 'white' }}>
                            Faça aqui sua inscrição em um de nossos campeonatos e acompanhe todas as etapas.
                        </Link>
                    </div>

                    <div className='publicHomeModuleImg'>
                        <Link to={'/index/publicEvents'} style={{ color: 'white' }}>
                            <i className="fas fa-microphone"></i>
                        </Link>
                    </div>
                    <div className='publicHomeModuleText'>
                        <Link to={'/index/publicEvents'} style={{ color: 'white' }}>
                            Confira aqui todos os eventos que estamos organizandos para você.
                        </Link>
                    </div>

                    <div className='publicHomeModuleImg'>
                        <Link to={'/index/publicPhotos'} style={{ color: 'white' }}>
                            <i className="fas fa-camera"></i>
                        </Link>
                    </div>
                    <div className='publicHomeModuleText'>
                        <Link to={'/index/publicPhotos'} style={{ color: 'white' }}>
                            Clique aqui e confira fotos de nossos campeonatos, eventos e de nossos atletas.
                        </Link>
                    </div>
                </div>
            </div> */}

            <div className='publicHomeFooter'>
                Desenvolvido por Alexis Barros | apenasalexis@gmail.com
            </div>
        </div>
    )
}

export default PublicHomeView